<template>
    <!-- <v-layout> -->
    <v-dialog v-model="dialog" eager max-width="600px">
        <template v-slot:activator="{ on }">
            <slot>
                <v-fab-transition v-if="isNew">
                    <v-btn class="mt-5" color="primary" @click="openDialog">{{ $t('Добавить') }}</v-btn>
                </v-fab-transition>
                <v-fab-transition v-else>
                    <v-btn icon v-on="on" text class="grey--text px-0 rounded-btn" :title="$t('Детализация документа')" dense @click="openEdit">
                        <v-icon>mdi-file-eye-outline</v-icon>
                    </v-btn>
                </v-fab-transition>
            </slot>
        </template>
        <LabeledCard :label="isNew ? $t('Добавление нового документа') : $t('Детализация документа')">
            <v-container class="pt-5 px-5" fluid>
                <v-form ref="documentForm">
                    <template v-if="contract_rid">
                        <v-row>
                            <v-select
                                dense
                                outlined
                                :label="$t('Договор')"
                                :items="CLT"
                                item-text="contract_number"
                                item-value="contract_rid"
                                v-model="contract_rid"
                                readonly
                                :hide-details="readonly"
                            >
                                <template #append><span></span></template>
                            </v-select>
                        </v-row>
                        <v-row class="mt-2">
                            <v-select
                                dense
                                outlined
                                :label="$t('Наименование объекта')"
                                :items="OLT"
                                item-text="object_name"
                                item-value="obj_contract_rid"
                                v-model="obj_contract_rid"
                                readonly
                                :hide-details="readonly"
                                :rules="requiredWhenDateEnd"
                            >
                                <template #append><span></span></template>
                            </v-select>
                        </v-row>
                    </template>
                    <v-row class="mt-2" v-else-if="ksk_house_rid">
                        <v-select
                            dense
                            outlined
                            :label="$t('Адреса дома')"
                            :items="KHLT"
                            item-text="address_full_name"
                            item-value="ksk_house_rid"
                            v-model="ksk_house_rid"
                            readonly
                            :hide-details="readonly"
                            :rules="requiredWhenDateEnd"
                        >
                            <template #append><span></span></template>
                        </v-select>
                    </v-row>
                    <v-row class="mt-2">
                        <v-select
                            dense
                            outlined
                            :label="$t('Наименование документа')"
                            :items="DTLT"
                            item-text="doc_type_name"
                            item-value="ahs_doc_type_rid"
                            v-model="ahs_doc_type_rid"
                            :readonly="readonly"
                            :hide-details="readonly"
                            :rules="[required]"
                        ></v-select>
                    </v-row>
                    <v-row class="mt-2">
                        <v-textarea maxlength="500" outlined auto-grow v-model="comment" :readonly="readonly" :label="$t('Комментарий')"></v-textarea>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="d-flex justify-start align-center">
                            <v-btn @click="clickInput" color="info">
                                <v-icon left>mdi-paperclip</v-icon>
                                <span> {{ $t('Приложить файл') }} </span>
                            </v-btn>
                            <input
                                style="display: none"
                                type="file"
                                ref="file"
                                accept=".jpg, .jpeg, .pdf"
                                name="file"
                                @change="processFile($event)"
                                id="file-input"
                            />
                            <span class="ml-2">{{ fileName }}</span>
                            <span style="color: red" v-if="showFileError">{{ $t('Обязательное поле') }}</span>
                        </v-col>

                        <span style="color: red">{{ $t('Объем прикрепляемого файла не должен превышать 28 Mb') }}</span>
                        <span style="color: red">{{ $t('Допустимы форматы файлов: jpg, jpeg, pdf') }}</span>
                    </v-row></v-form
                ><v-row class="mt-2" v-if="isNew">
                    <v-col cols="12" class="d-flex justify-end">
                        <v-btn outlined color="primary" @click="dialog = false">{{ $t('Закрыть') }}</v-btn>
                        <v-btn class="ml-5" color="primary" @click="clickSave" :loading="loading">{{ $t('Сохранить') }}</v-btn>
                    </v-col>
                </v-row></v-container
            ></LabeledCard
        >
    </v-dialog>
    <!-- </v-layout> -->
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LabeledCard from '@/components/ui/LabeledCard.vue';
import translate from '@/utils/translate.util';
import BinCheckMixin from '@/mixins/BIN_Checker';
import FormValidator from '@/mixins/FormValidator';
import fileSaver from 'file-saver';
export default {
    name: 'AddDocument',
    mixins: [BinCheckMixin, FormValidator],
    props: ['document', 'contract_rid', 'obj_contract_rid', 'ksk_house_rid'],
    components: { LabeledCard },
    data: () => ({
        isNew: true,
        dialog: false,
        ahs_doc_type_rid: null,
        comment: null,
        readonly: true,
        // contract_rid: null,
        // obj_contract_rid: null,
        // ksk_house_rid: null,
        loading: false,
        fileName: null,
        attachment_link_rid: null,
        showFileError: false
    }),
    computed: {
        ...mapState('prescription', ['iengineer_rid', 'EngineerKSKHousesList', 'EngineerContractsList', 'EngineerObjectContractsList']),
        ...mapState('documents', ['DocTypeList', 'file']),
        ...mapState('users', ['userInfo']),
        DTLT() {
            return translate(this.DocTypeList, 'full', this.$i18n.locale);
        },
        CLT() {
            return translate(this.EngineerContractsList, 'full', this.$i18n.locale);
        },
        OLT() {
            return translate(this.EngineerObjectContractsList, 'full', this.$i18n.locale);
        },
        KHLT() {
            return translate(this.EngineerKSKHousesList, 'full', this.$i18n.locale);
        },
        requiredWhenDateEnd: function(v) {
            let req = !this.obj_contract_rid && !this.ksk_house_rid;
            let reqr = this.obj_contract_rid && this.ksk_house_rid;
            if (reqr) {
                return [v => !reqr || this.$t('Необходимо выбрать адрес дома или обьект')];
            }
            return [v => !req || this.$t('Обязательное поле')];
        }
    },
    methods: {
        ...mapActions('prescription', ['getEngineerKSKHousesList', 'getEngineerObjectContractsList', 'getEngineerContractsList', 'attachmentsTempInsert']),
        ...mapActions('documents', ['postDoc', 'attachmentsTempInsert', 'getFile', 'getRefAhsDocTypes']),
        ...mapActions('users', ['getUserInfo']),
        openDialog() {
            this.$refs.documentForm.resetValidation();
            this.dialog = true;
            this.readonly = false;
            this.ahs_doc_type_rid = null;
            this.comment = null;
            this.resetInput();
            this.fileName = '';
        },
        async clickSave() {
            this.loading = true;
            try {
                this.showFileError = false;
                if (!this.attachment_link_rid) {
                    this.showFileError = true;
                }
                if (!this.$refs.documentForm.validate() || this.showFileError) return;
                await this.getUserInfo();
                let data = {};
                data.ahs_doc_type_rid = this.ahs_doc_type_rid;
                data.record_id = null;
                data.to_delete = 0;
                data.attachment_link_rid = this.attachment_link_rid;
                data.comment = this.comment;
                if (this.obj_contract_rid) data.object_contracts = [{ object_contract_rid: this.obj_contract_rid, to_delete: 0 }];
                if (this.ksk_house_rid) data.ksk_houses = [{ ksk_house_rid: this.ksk_house_rid, to_delete: 0 }];
                data.user_rid = this.userInfo.record_id;
                //console.log(data);
                const res = await this.postDoc({ nvcDocumentsData: data });
                if (this.document && res && res.successfull) {
                    this.document.ahs_document_rid = res.data.ahs_document[0].record_id;
                    this.document.doc_type_name = this.DTLT.find(x => x.ahs_doc_type_rid === this.ahs_doc_type_rid).doc_type_name;
                }

                this.$emit('documentAdded', res.data.ahs_document[0].record_id);

                if (res && res.successfull) {
                    let color = 'success';
                    let message = this.$t('Документ успешно добавлен');
                    this.$store.dispatch('base/showMessage', { color, message });
                }
                this.dialog = false;
            } finally {
                this.loading = false;
            }
        },
        clickInput() {
            this.$refs.file.click();
        },

        async processFile(evt) {
            this.attachment_link_rid = null;
            //this.file = null;
            if ((evt.target.files[0].size < 28000000 && evt.target.files[0].type == 'image/jpeg') || evt.target.files[0].type == 'application/pdf') {
                this.fileName = evt.target.files[0].name;
                let formData = new FormData();
                formData.append('file', evt.target.files[0]);
                let response = await this.attachmentsTempInsert(formData);
                this.attachment_link_rid = response.data.attachment_link_rid;
                this.resetInput();
                this.showFileError = false;
            } else {
                this.fileName = '';
                this.attachment_link_rid = null;
            }
        },
        resetInput() {
            document.getElementById('file-input').value = '';
        }
    },
    watch: {
        async contract_rid() {
            this.getEngineerObjectContractsList({ icontract_rid: this.contract_rid, iengineer_rid: this.iengineer_rid });
        }
    },
    async created() {
        await this.getRefAhsDocTypes();
    }
};
</script>
